import { Link } from "react-router-dom";
import type { VideoItem } from "@/types/video";
import {
  formatDate,
  formatDuration,
  formatViews,
  getCategoryName,
} from "@/lib/videos";

interface VideoCardProps {
  video: VideoItem;
  showCategory?: boolean;
}

export default function VideoCard({ video, showCategory = true }: VideoCardProps) {
  return (
    <Link to={`/video/${video.id}`} className="group flex cursor-pointer flex-col">
      <div className="relative aspect-video w-full overflow-hidden rounded-lg bg-background-200">
        <img
          src={video.cover}
          alt={video.title}
          title={`${video.title} - 茄子视频短视频`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.04]"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/45 via-transparent to-transparent opacity-0 transition-opacity duration-300 group-hover:opacity-100"></div>
        <span className="absolute left-1/2 top-1/2 flex h-11 w-11 -translate-x-1/2 -translate-y-1/2 scale-90 items-center justify-center rounded-full bg-background-50/90 text-primary-600 opacity-0 transition-all duration-300 group-hover:scale-100 group-hover:opacity-100">
          <i className="ri-play-fill text-xl"></i>
        </span>
        <span className="absolute bottom-2 right-2 rounded bg-foreground-950/75 px-1.5 py-0.5 font-label text-[11px] font-medium tracking-wide text-background-50">
          {formatDuration(video.duration)}
        </span>
      </div>
      <div className="mt-3 flex flex-1 flex-col">
        <h3 className="line-clamp-2 text-sm font-medium leading-snug text-foreground-900 transition-colors group-hover:text-primary-600 md:text-[15px]">
          {video.title}
        </h3>
        <div className="mt-2 flex flex-wrap items-center gap-x-2 gap-y-1 text-xs text-foreground-500">
          {showCategory && (
            <span className="rounded-full bg-secondary-100 px-2 py-0.5 text-[11px] text-secondary-900">
              {getCategoryName(video.categoryId)}
            </span>
          )}
          <span className="flex items-center gap-1">
            <i className="ri-play-list-2-line text-sm"></i>
            {formatViews(video.views)}
          </span>
          <span className="text-foreground-400">{formatDate(video.uploadTime)}</span>
        </div>
      </div>
    </Link>
  );
}